import styled from 'styled-components';

import { fadeIn } from '../../styles/shared.style';

export const NoTickets = styled.div<{ $reduceHeight : boolean}>`
    display: flex;
    width: 100%;
    min-height: ${({ $reduceHeight }) => $reduceHeight ? 'calc(100vh - 185px - 60px)' : 'calc(100vh - 185px)'};
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    text-align: center;
    opacity: 1;
    animation: ${fadeIn} 3s forwards;
`;

export const Image = styled.img`
    width: 191px;
    max-width: 174px;
    height: auto;
`;

export const Title = styled.strong`
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: center;
`;

export const Subtitle = styled.p`
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    margin-bottom:-0.8rem;
    text-align: center;
`;
